import { render, staticRenderFns } from "./preservationInfo.vue?vue&type=template&id=184f16c8&scoped=true&"
import script from "./preservationInfo.vue?vue&type=script&lang=js&"
export * from "./preservationInfo.vue?vue&type=script&lang=js&"
import style0 from "./preservationInfo.vue?vue&type=style&index=0&id=184f16c8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "184f16c8",
  null
  
)

export default component.exports